import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecordFilterTypes } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const isSaveEnabledValidation = ({
  componentState,
  isOverDataSourceCountLimit
}) => {
  if (!componentState || !componentState.recordFilterDefinition) {
    throw Error('Component state is undefined');
  }
  if (isOverDataSourceCountLimit) {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.over-data-source-limit.title"
      })
    };
  }
  if (!componentState.objectTypeId) {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-object-id"
      })
    };
  }
  switch (componentState.recordFilterDefinition.recordFilterType) {
    case RecordFilterTypes.ASSOCIATION_LABEL:
      return validateAssociationFilterType(componentState);
    case RecordFilterTypes.ASSOCIATION_TIMESTAMP:
      return validateAssociationTimestampFilterType(componentState);
    case RecordFilterTypes.MATCHING_PROPERTY:
      return validatePropertyMatchingFilterType(componentState);
    default:
      return {
        isSaveEnabled: false,
        saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-filter-by"
        })
      };
  }
};
function validateAssociationFilterType(componentState) {
  const {
    recordFilterDefinition: {
      associationId
    }
  } = componentState;
  if (!associationId) {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-association-id"
      })
    };
  }
  return {
    isSaveEnabled: true
  };
}
function validateAssociationTimestampFilterType(componentState) {
  const {
    recordFilterDefinition: {
      associationId
    }
  } = componentState;
  if (!associationId) {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-association-id"
      })
    };
  }
  return {
    isSaveEnabled: true
  };
}
function validatePropertyMatchingFilterType(componentState) {
  const {
    recordFilterDefinition: {
      propertyName,
      matchingValue
    }
  } = componentState;
  if (!propertyName || !matchingValue) {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-property-name"
      })
    };
  }
  if (matchingValue.type === 'STATIC' && matchingValue.value.trim() === '') {
    return {
      isSaveEnabled: false,
      saveValidationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.saving.validation.missing-property-value"
      })
    };
  }
  return {
    isSaveEnabled: true
  };
}
export default isSaveEnabledValidation;